<template>
	<div class="tb-tree-select-list" :class="{'width-max-content': widthMaxContent}">
		<!-- Label -->
		<label v-if="labelText">
			{{ labelText }}
		</label>
		<!-- Search and Filter -->
		<md-field v-if="searchAllow">
			<label>{{ $t("common.search") }}</label>
			<md-input @input="search" :value="searchValue" :disabled="disabled"/>
		</md-field>
		<div v-else style="margin-top: 10px;"></div> <!-- Dummy div to keep the same margin as with the search enabled -->
		<!-- Tree content -->
		<div :style="listStyle" class="tree-container">
			<el-tree :data="treeOptions"
					 :props="treeProperties"
					 :node-key="treeProperties.nodeKey"
					 @check="onNodeChecked"
					 :filter-node-method="filterTreeNode"
					 :show-checkbox="true"
					 :highlight-current="true"
					 :empty-text="emptyText"
					 :class="treeClass"
					 ref="tree"
			></el-tree>
		</div>
	</div>
</template>

<script>
import TreeSelectBaseComponent from "@/components/templates/common/TreeSelectBaseComponent";

export default {
	extends: TreeSelectBaseComponent,
	props: {
		value: { type: Array, default: [] }, // Selected values list
		labelText: { type: String, default: null }, // Optional label name for this list
		listMinHeight: { type: Number, default: 0 }, // Minimum height for the list container. No minimum by default
		listMaxHeight: { type: Number, default: 0 }, // Maximum height for the list container. Scrolling is enabled if the content exceeds the height. No maximum by default
		widthMaxContent: { type: Boolean, default: false },
		treeClass: { type: String | Array, default: null }, // General class applied to the tree
	},
	computed: {
		listStyle() {
			return {
				...(this.listMinHeight > 0 ? { 'min-height': this.listMinHeight + 'px' } : {}),
				...(this.listMaxHeight > 0 ? { 'max-height': this.listMaxHeight + 'px' } : {}),
			}
		},
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/base_variables.scss";

.tb-tree-select-list {
	display: flex;
	flex-direction: column;

	&.width-max-content {
		width: max-content;
		max-width: 100%;
	}

	.tree-container {
		overflow: auto;
		padding-right: 1rem;
	}
}
</style>
